export const VERIFY_TYPE = {
  EMAIL: 0,
  AUTHEN: 1,
}
